import React from 'react';
import { brokerStatuses } from '../../../../schemas/broker';
import { Label } from 'react-bootstrap';
import displayName from '../../../../helpers/displayName';
import './TrackingLinkLabel.scss';

const getLabelStyle = (status) => {
  switch (status) {
    case 'pending':
    case 'awaiting approval':
      return 'warning';

    case 'active':
      return 'success';

    case 'declined':
    case 'inactive':
      return 'danger';

    default:
      return 'info';
  }
};

const TrackingLinkLabel = ({ name, status }) => {
  const brokerStatus = brokerStatuses[status];
  return (
    <div className={'tracking-link-label'}>
      <div className="tracking-link-label--title">{name}</div>
      <Label
        className="pull-right tracking-link-label--label"
        bsStyle={getLabelStyle(status)}
      >
        {displayName(brokerStatus)}
      </Label>
    </div>
  );
};
export default TrackingLinkLabel;
